import React from "react";
import { useSelector } from "react-redux";
import { getContent } from "../../../utils/main";
import { Link } from "react-router-dom";

const Welcome = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  return (
    <div className="welcome-wrapper">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="img-wrapper">
              <img
                src={require("./../../../assets/images/front_image_green.jpg")}
                alt="Welcome"
              />
              <Link to={"/welcome"}>
                <h4>{getContent(content, "Welcome to Turkmenistan!", lang)}</h4>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
